import { useRef, useState } from 'react';

export default function SignOutButton({onSignOut, className = ''}: {onSignOut: () => void | Promise<void>; className?: string}) {
  const lock = useRef(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const run = async () => {
    if(lock.current) return;
    lock.current = true; setPending(true); setError('');
    try { await onSignOut(); } catch { setError('Sign out could not complete. Please try again.'); }
    finally { lock.current = false; setPending(false); }
  };
  return <><button type="button" className={`srs-signout ${className}`} disabled={pending} aria-busy={pending} onClick={run}>{pending ? 'Signing out…' : 'Sign out'}</button>{error && <span className="srs-control-help" role="alert">{error}</span>}</>;
}
